"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Image: function() {
        return _Image.Image;
    },
    imageClassNames: function() {
        return _Image.imageClassNames;
    },
    renderImage_unstable: function() {
        return _Image.renderImage_unstable;
    },
    useImageStyles_unstable: function() {
        return _Image.useImageStyles_unstable;
    },
    useImage_unstable: function() {
        return _Image.useImage_unstable;
    }
});
const _Image = require("./Image");
